import React from 'react';
import pure from 'recompose/pure';

const data = [
  {
    title: 'What can you use this app for?',
    text: `Initially, this app supports plotting of time series. Select which main
        asset you want to focus on. Add multiple time series to a chart by
        typing a partial tag ID or tag name in the search box. Select an overall
        time frame for the chart, and zoom in on the timeline to explore
        details. Zoom each y-axis individually. Move the mouse over the chart to
        inspect values. Click on a tag to set the plot color. Download the chart
        to Excel to explore further. Provide a title for your chart, and save it
        so that you can access it later in the chart list.`,
  },
  {
    title: 'What data is currently available?',
    text: `Currently, you can access time series data extracted from Osisoft PI. The Cognite Data Platform (CDP) contains both historic and real-time data for all AkerBP assets. Additional data sources will be added in the coming months. Historic data is pre-aggregated at different resolutions to ensure excellent performance for both long term and real-time data.`,
  },
  {
    title: 'Who can see the charts that I create?',
    text:
      'Everyone can see all charts created within the AkerBP project. Only the creator of a chart can edit or delete a chart. You can filter the chart list to see only the charts that you have created.',
  },
  {
    title: 'Who has access to this application?',
    text:
      'Everyone with an AkerBP username and password can log in to this application.',
  },
  {
    title: 'How often will the application be updated?',
    text:
      'We are continuously developing and deploying the Operational Intelligence app. You can expect improvements and fixes every week, and new features every month. Features that are in development are considered experimental. Experimental features are by default hidden from the navigation menu, but you can turn them on if you want to take a peek at what is coming. That a look at the roadmap page for more information about future plans.',
  },
  {
    title: 'How can I provide feedback?',
    text: `You can provide feedback to the Cognite Product Management team by sending an email to jan.helge.sageflat@cognite.com. You are always welcome to drop by at our office on the 4th floor at Fornebuporten.`,
  },
];

const IntroductionComponent = () => (
  <div className="container-fluid">
    <div className="row">
      <div className="col-xs-10 col-xs-offset-1 col-lg-6 col-lg-offset-3">
        <h2>Welcome to the Operational Intelligence Application!</h2>
        <p>
          This is the very beginning of a new app for gaining insight from IIOT
          and business data. Even though it is early days, we appreciate you
          taking the time to learn and use this app. We have huge plans going
          forward, but we would love your feedback to help tune the direction
          and resolve any annoying issues. It is our goal that you are going to
          love using this app every day.
        </p>
        {data.map(({ title, text }, i) => (
          <div key={i}>
            <p className="lead">{title}</p>
            <p>{text}</p>
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default pure(IntroductionComponent);



// WEBPACK FOOTER //
// ./src/components/IntroductionComponent/IntroductionComponent.js